'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$20() {
  this.b5i = null;
  this.b5j = false;
}
export { $c_Lpresto_LoginPageView$$anon$20 as $c_Lpresto_LoginPageView$$anon$20 };
$p = $c_Lpresto_LoginPageView$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$20;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$20() {
}
export { $h_Lpresto_LoginPageView$$anon$20 as $h_Lpresto_LoginPageView$$anon$20 };
$h_Lpresto_LoginPageView$$anon$20.prototype = $p;
$p.P = (function() {
  if ((!this.b5j)) {
    this.b5i = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.b5j = true;
  }
  return this.b5i;
});
var $d_Lpresto_LoginPageView$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$20, "presto.LoginPageView$$anon$20", ({
  Ml: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$20 as $d_Lpresto_LoginPageView$$anon$20 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$20.js.map
